import { render, staticRenderFns } from "./ABenefit.vue?vue&type=template&id=037cb803&scoped=true&"
import script from "./ABenefit.vue?vue&type=script&lang=js&"
export * from "./ABenefit.vue?vue&type=script&lang=js&"
import style0 from "./ABenefit.vue?vue&type=style&index=0&id=037cb803&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037cb803",
  null
  
)

export default component.exports